const addLeadingZeroes = (n) => (n <= 9 ? '0' + n.toString() : n.toString());

export const formatDate = (rawDate) => {
  const date = new Date(rawDate);
  return `${date.getFullYear()}-${addLeadingZeroes(
    date.getMonth() + 1
  )}-${addLeadingZeroes(date.getDate())}`;
};
